import { AxiosResponse } from 'axios';
import { ApiServiceBase } from '../api-service-base';
import {
  GroupedKpiMetricResponse,
  IGetGroupedKpiMetricProps,
  IGetKpiMetricProps,
  IGetRevenueDistributionProps,
  KpiMetricResponse,
  IGetRevenueByDeviceProps,
  RevenueByDeviceResponse,
  RevenueDistributionResponse,
} from '../types/analytics';

export class KPIService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl({ shopId }: { shopId: number }): string {
    return `${this.serviceBaseUri}/${shopId}/data-insights`;
  }

  async getKpiMetric({
    shopId,
    kpiType,
    timeRange,
    product,
    device,
  }: IGetKpiMetricProps): Promise<KpiMetricResponse> {
    const params = new URLSearchParams({ timeRange, product });
    if (device && device !== 'all') params.set('device', device);
    const url = `${this.getUrl({ shopId })}/kpis/${kpiType}?${params.toString()}`;

    const response: AxiosResponse<KpiMetricResponse> = await this.httpService.get({ url });

    return response.data;
  }

  async getGroupedKpiMetric({
    shopId,
    kpiType,
    timeRange,
    product,
    device,
    compareToPreviousPeriod,
  }: IGetGroupedKpiMetricProps): Promise<GroupedKpiMetricResponse> {
    const params = new URLSearchParams({
      timeRange,
      product,
      compareToPreviousPeriod: String(compareToPreviousPeriod),
    });
    if (device && device !== 'all') params.set('device', device);
    const url = `${this.getUrl({ shopId })}/grouped/${kpiType}?${params.toString()}`;

    const response: AxiosResponse<GroupedKpiMetricResponse> = await this.httpService.get({ url });

    return response.data;
  }

  async getRevenueDistribution({
    shopId,
    timeRange,
    product,
    device,
  }: IGetRevenueDistributionProps): Promise<RevenueDistributionResponse> {
    const params = new URLSearchParams({ timeRange, product });
    if (device && device !== 'all') params.set('device', device);
    const url = `${this.getUrl({ shopId })}/revenue-distribution?${params.toString()}`;

    const response: AxiosResponse<RevenueDistributionResponse> = await this.httpService.get({
      url,
    });

    return response.data;
  }

  async getRevenueByDevice({
    shopId,
    timeRange,
    product,
  }: IGetRevenueByDeviceProps): Promise<RevenueByDeviceResponse> {
    const params = new URLSearchParams({ timeRange, product });
    const url = `${this.getUrl({ shopId })}/revenue-by-device?${params.toString()}`;

    const response: AxiosResponse<RevenueByDeviceResponse> = await this.httpService.get({
      url,
    });

    return response.data;
  }
}

export const kpiService = new KPIService();
